export default {
  Menu: [
    {
      name: "Calendar",
      icon: "mdi-calendar-month",
      route: { name: "CalendarView" },
      divider: false,
      permission: 1,
    },
    {
      name: "Invoices",
      icon: "mdi-file-document-outline",
      route: { name: "InvoiceBrowseView" },
      divider: false,
      permission: 31,
    },
    {
      name: "Admin Invoices",
      icon: "mdi-file-document-outline",
      route: { name: "AdminInvoiceBrowseView" },
      divider: false,
      permission: 34,
    },
    {
      name: "Orders",
      icon: "mdi-cart-outline",
      route: { name: "OrderBrowseView" },
      divider: false,
      permission: 43,
    },
    {
      name: "Deals",
      icon: "mdi-handshake",
      route: { name: "DealBrowseView" },
      divider: false,
      permission: 37,
    },
    {
      name: "Transactions",
      icon: "mdi-swap-horizontal",
      route: { name: "WiseTransactionBrowseView" },
      divider: false,
      permission: 39,
    },
     {
      name: "Reviews",
      icon: "mdi-message-draw",
      route: { name: "ReviewBrowseView" },
      divider: true,
      permission: 50,
    },
    {
      name: "Admins",
      icon: "mdi-account-tie",
      route: { name: "AdminBrowseView" },
      divider: false,
      permission: 2,
    },
    {
      name: "Technicians",
      icon: "mdi-video-account",
      route: { name: "TechnicianBrowseView" },
      divider: false,
      permission: 6,
    },
    {
      name: "Users",
      icon: "mdi-account",
      route: { name: "UserBrowseView" },
      divider: false,
      permission: 10,
    },
    {
      name: "Wise Users",
      icon: "mdi-account-cash",
      route: { name: "WiseUserBrowseView" },
      divider: false,
      permission: 39,
    },
     {
      name: "Wise Jars",
      icon: "mdi-pail-plus",
      route: { name: "WiseJarBrowseView" },
      divider: true,
      permission: 54,
    },
    // {
    //   name: "Customers",
    //   icon: "mdi-account-group",
    //   route: { name: "CustomerBrowseView" },
    //   divider: true,
    //   permission: 1,
    // },
    {
      name: "Roles",
      icon: "mdi-account-cog",
      route: { name: "RoleBrowseView" },
      divider: false,
      permission: 14,
    },
    {
      name: "Products",
      icon: "mdi-sitemap",
      route: { name: "ProductBrowseView" },
      divider: false,
      permission: 23,
    },
    //   {
    //   name: "Technician Products",
    //   icon: "mdi-sitemap",
    //   route: { name: "TechnicianProductBrowseView" },
    //   divider: false,
    //   permission: 23,
    // },
    {
      name: "Locations",
      icon: "mdi-map-marker-multiple",
      route: { name: "LocationBrowseView" },
      divider: false,
      permission: 27,
    },
    {
      name: "Countries",
      icon: "mdi-earth",
      route: { name: "CountryBrowseView" },
      divider: false,
      permission: 6,
    },
     {
      name: "Utils",
      icon: "mdi-tools",
      route: { name: "UtilBrowseView" },
      divider: false,
      permission: 46,
    },
    {
      name: "Activity logs",
      icon: "mdi-table-clock",
      route: { name: "ActivityLogBrowseView" },
      divider: true,
      permission: 17,
    },
  ],
};
